<template>
  <v-form ref="form_3" v-model="formValid" lazy-validation>
    <div v-if="form_fields.ret_date != null">
      <v-container>
        <v-layout column>
          <v-flex xs12 class="ma-0 pa-0 bump_up">
            <FlightSearchDescription :descriptions="descriptions" />
          </v-flex>
          <v-flex xs12>
            <v-container>
              <v-layout row wrap align-center>
                <v-flex xs12 sm6 class="pt-4 pl-4 pb-2">
                  <h1>Returning Flight</h1>
                </v-flex>
								<v-flex xs12 sm2 class="pt-2">
									<v-btn @click="removeReturnFlight()" color="accent" class="accent">REMOVE</v-btn>
								</v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <CountdownTimer />
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <div v-if="minMode !== true || showForm === true" class="ml-3">
            <v-layout row wrap align-center>
              <v-flex xs12 sm4>
                <div class="head_lg">
                  Return Date
                </div>
                <v-text-field
                  :value="ret_date"
                  hint="YYYY-MM-DD format"
                  :rules="retDateRules"
                  :clearable="false"
                  :show-current="false"
                  @focus="calRet = true"
                  :append-icon="calRet ? 'close' : ''"
                  @click:append="hideCalRet"
                  mask="####-##-##"
                  :return-masked-value="true"
                  outline
                ></v-text-field>
                <v-date-picker
                  ref="dep_date_picker"
                  v-show="calRet === true"
                  v-model="ret_date"
                  type="date"
                  :landscape="false"
                  format="yyyy-MM-dd"
                  :allowedDates="enabledDatesReturn"
                  max-width="200px"
                  @input="handleInput()"
                  :reactive="true"
                >
                </v-date-picker>
              </v-flex>
              <v-flex xs12 sm8>
                <v-layout row wrap align-center>
                  <v-flex class="ma-3 pt-4" xs12 sm5>
                    <v-checkbox
                      v-model="samepassengers"
                      :label="'Same ' + paxTerm + ' Departing and Returning'"
                      color="primary"
											@change="reloadFlightSearch()"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex v-show="!samepassengers" class="ml-3" xs12 sm6 align-start>
                    <PassengerSelectReturn />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>
          </div>
          <v-layout row v-if="minMode !== true">
            <LowestFares></LowestFares>
          </v-layout>
          <v-layout row class="mt-2">
            <v-flex xs12 class="pr-1">
              <FlightSearchLoader search-type="returning" />
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12 class="error_container">
            <ShowErrors />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div v-else>
      <ErrorPage
        label="No Return Date Selected"
        desc="Please select a return date, or continue to purchase a one-way ticket"
        icon="airplanemode_inactive"
        :iconSize="getErrorIconSize()"
      />
    </div>

    <v-layout class="justify-center my-4">
      <v-btn
        @click="setPreviousStep()"
        class="accent_light"
      >
        <v-icon class="reverse">arrow_right_alt</v-icon>
        Previous
      </v-btn>
      <v-btn
        @click="setNextStep()"
        :disabled="!testCompleteStep(1) || errors.length > 0"
        class="accent"
      >
        Continue
        <v-icon>arrow_right_alt</v-icon>
      </v-btn>
    </v-layout>
    <v-layout row xs12 class="search_pad" v-if="loading === true">
      &nbsp;
    </v-layout>
  </v-form>
</template>

<script>
import Vue from "vue";
import store from "../../store";
import Router from "vue-router";
Vue.use(Router);
import Shared from "@/mixins/Shared";
import BookingFormMixin from "@/mixins/BookingFormMixin";
import FlightSearchLoader from "@/components/forms/sections/FlightSearchLoader.vue";
import FlightSearchDescription from "@/components/forms/FlightSearchDescription.vue";
import ErrorPage from "@/components/pages/ErrorPage.vue";
import ShowErrors from "@/components/pages/ShowErrors.vue";
import PassengerSelectReturn from "@/components/forms/sections/PassengerSelectReturn.vue";
import LowestFares from "@/components/LowestFares.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";

export default {
  name: "FormReturning",
  store: store,
  mixins: [BookingFormMixin, Shared],
  components: {
    FlightSearchDescription,
    FlightSearchLoader,
    ErrorPage,
    PassengerSelectReturn,
    ShowErrors,
    LowestFares,
    CountdownTimer
  },
  data() {
    return {
      formValid: false,
      calRet: false,
      hideForm: false
    };
  },
  computed: {
    descriptions() {
      return this.getAllFlightDescriptions();
    }
  },
  methods: {
    handleInput() {
      this.dpInputRet();
      this.calRet = false;
    }
  }
};
</script>
